export default class LoginService {

    loginJson;
    uiErrorHandler;
    uiErrorHandlerClear;

    constructor(uiErrorHandler, uiErrorHandlerClear) {
        this.uiErrorHandler = uiErrorHandler;
        this.uiErrorHandlerClear = uiErrorHandlerClear;
        console.log(this.uiErrorHandler);
    }
    async checkForSSO(email) {
        const response = await this.myfetch(`/api/Saml/Login/?json=true`, {"username": email});

        const json = await response.json();
        if (json.redirect.includes("Redirect=&errorCode=1")) {
            return false;
        }
        else {
            return json.redirect;
        }
    }

    async login(username, password) {
        const uri = window.location.href.includes('Redirect') ?
            '/VM/services/public/Login/Login.aspx?json=true&' + window.location.href.split('login.html?').pop() :
            '/VM/services/public/Login/Login.aspx?json=true'

        const response = await this.myfetch(uri, {"username": username, "password": password});
        this.loginJson = await response.json();
    }

    isLoginSuccess() {
        return this.loginJson.redirect && this.loginJson.redirect !== '';
    }

    getLoginRedirect() {
        return this.loginJson.redirect;
    }

    getLoginErrorMessage() {
        return this.loginJson.message;
    }

    async googleSignIn() {
        const response = await this.myfetch(`/VM/services/public/google/login.aspx?json=true`, {"username": ""});
        const json = await response.json();
        return json.redirect;
    }

    errorHandler(error) {
        fetch(`${process.env.VUE_APP_ENV_SERVER}/lpi-service/handleError`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({"error": error.toString(), "url": window.location.href})
        });
    }

    async resetPassword(email) {
        const response = await this.myfetch(`/VM/services/public/forgot.aspx?json=true`, {"username": email});
        const message = await response.text();
        return message;
    }

    async myfetch(endpoint, body) {
        // Clear any existing API errors if they exist
        this.uiErrorHandlerClear();

        const response = await fetch(`${process.env.VUE_APP_ENV_SERVER + process.env.VUE_APP_ENV_BUILD + endpoint}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'},
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            // TODO add more data here
            const error = (response.data && response.data.message) || response.statusText;
            this.errorHandler(error);

            this.uiErrorHandler();
            throw 'API issue';
        }

        return response;
    }
}
